import { render, staticRenderFns } from "./matching-list.view.vue?vue&type=template&id=5b6ceef9&"
import script from "./matching-list.view.vue?vue&type=script&lang=ts&"
export * from "./matching-list.view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports